import React from "react";
import {ListEditor} from "../../components/list-editor";
import * as yup from "yup";
import { FieldTableColumnProps } from '../../components/FieldTable/FieldTableTypes';
import {
    ClientCompanyGroup, ClientCompanyGroupQueryQuery,
    useClientCompanyGroupQueryQuery,
    useClientCompanyGroupsMutationMutation
} from "../../generated/graphql";
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

const columns:FieldTableColumnProps<ClientCompanyGroup>[] = [{
    header: 'Name',
    accessor: 'label',
    dataType:'text'
}
];


function newRow():ClientCompanyGroup {
    return {
        id:uniqueId(),
        label:''
    }
}

const schema =  yup.array().of(
        yup.object().shape({
        'label': yup.string().required()
    })
);

function getValues(data: ClientCompanyGroupQueryQuery) {
    return data?.clientCompanyGroups.data;
}

const ClientCompanyGroups = ()=> {
    const url = useLocation().pathname;
    const query = useClientCompanyGroupQueryQuery();
    const [mutation,mutationResult] = useClientCompanyGroupsMutationMutation();
    return (
        <ListEditor 
           columns={columns}
           validationSchema={schema}
           saveResult={mutationResult}
            title="Client Company Groups"
            query={query}
            mutation={mutation}
           getValues={getValues}
           className="client-company-groups"
           baseUrl={url}
            permission="clientcompanygroups"
            newRow={newRow}
            newRowLabel="Add Client Company Group"
        />);
}
export default ClientCompanyGroups;
